/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheEnvironmentCallout.vue?vue&type=template&id=665b52e1&scoped=true"
import script from "./TheEnvironmentCallout.ts?vue&type=script&lang=ts&external"
export * from "./TheEnvironmentCallout.ts?vue&type=script&lang=ts&external"
import style0 from "./TheEnvironmentCallout.vue?vue&type=style&index=0&id=665b52e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b52e1",
  null
  
)

export default component.exports